import getFragmentHandler from '../../../utils/getFragmentHandler';

interface LoginPageParameters {
  loginMessage: string;
  emailHint: string;
  nudge: string;
  consent: string;
  adobe_mc: string;
  realm: string | undefined;
}

export default (): LoginPageParameters => {
  const fragmentHandler = getFragmentHandler();

  const {
    login_msg: loginMessage,
    email_hint: emailHint,
    nudge,
    consent,
    adobe_mc,
    realm,
  } = fragmentHandler
    ? (fragmentHandler.getSearchParams() as Record<string, string>)
    : {
        login_msg: '',
        email_hint: '',
        nudge: '',
        consent: '',
        adobe_mc: '',
        realm: '',
      };

  return {
    loginMessage,
    emailHint,
    nudge,
    consent,
    adobe_mc,
    realm,
  };
};
